<!-- the coreFeature booleans are reversed because the feature is technically on right now -->
<div class="e11-flex">
  <div class="e11-w-1/6"></div>
  <div class="e11-text-center e11-w-4/6">
    <e11-chart-percentage [id]="'job-matching-chart'" [data]="job" [size]="'80px'"></e11-chart-percentage>
    <h4 class="e11-mt-5">{{ 'Job Match' | translate }}</h4>
  </div>
  <div class="e11-w-1/6"></div>
</div>
